// @module Tavanoteam.ItemPromotions.ItemPromotions
define('Tavanoteam.ItemPromotions.ItemPromotions.Modal.View'
,	[
	'tavanoteam_itempromotions_itempromotions_modal.tpl'

	,	'Backbone'
	,	'Utils'
	,	'jQuery'
	,	'underscore'
    ]
, function (
	tavanoteam_itempromotions_itempromotions_modal_tpl

	,	Backbone
	,	Utils
	,	jQuery
	,	_
)
{
    'use strict';

	// @class Tavanoteam.ItemPromotions.ItemPromotions.Modal.View @extends Backbone.View
	return Backbone.View.extend({

		template: tavanoteam_itempromotions_itempromotions_modal_tpl

	,	initialize: function (options) {

			Backbone.View.prototype.initialize.apply(this, arguments);

			var self = this;

			//Get Options
			this.container = options.container;
			this.promotions = options.promotions;

		}

		//@method getContext @return Tavanoteam.ItemPromotions.ItemPromotions.Modal.View.Context
	,	getContext: function getContext()
		{
			var self = this;
			
			//Get Promotions
			this.promotions = this.promotions || [];

			//Create Promotions Array
			var getPromotions = this.promotions;
			this.promotionsArr = [];

			_.each(getPromotions, function(promotion){

				var promotionsObj = {};

				promotionsObj.name = promotion.promotionName;
				promotionsObj.description = promotion.promotionDescription;
				promotionsObj.code = promotion.promotionCode;

				self.promotionsArr.push(promotionsObj);

			});

			//@class Tavanoteam.ItemPromotions.ItemPromotions.Modal.View.Context

			return {
				itemPromotions: this.promotionsArr ? this.promotionsArr : []
			};
		}
	});
});
